import React, { ReactElement } from 'react';
import EConsentModal from "../structure/EConsentModal";
import QuestionPanel from "../structure/QuestionPanel";
import { PdsIconClock, PdsIconEdit, PdsIconFile, PdsIconPhone } from "@principal/design-system-icons-react";
import IconWithContent from "../structure/IconWithContent";
import HorizontalRule from "../structure/HorizontalRule";
import IncompleteIntakeStart from "../structure/IncompleteIntakeStart";
import { FormValues } from "./FormValues";
import { PdsHeading } from "@principal/design-system-react";
import { canSignIn, findFormsUrlFor, findPluralFor } from "../enums/Party";
import { useFormikContext } from "formik";

export type StartProps = {
    canSignIn?: boolean,
    neededItems: (ReactElement | string)[],
    niceToHaveItems?: (ReactElement | string)[],
    detailsText?: (ReactElement | string),
    children?: React.ReactNode
}

const Start = (props: StartProps) => {
    const { values } = useFormikContext<FormValues>();
    const party = values.party
    const formsUrl = findFormsUrlFor(party)
    const partyPlural = findPluralFor(party);
    const niceToHaveItems = props.niceToHaveItems;
    return (
        <QuestionPanel
            headerText={
                <div className="flex-gap">
                    <PdsHeading headingTag="h3">For {partyPlural}</PdsHeading>
                    <PdsHeading headingTag="h4">What to expect</PdsHeading>
                </div>}
            detailsText={<div className="flex-gap">
                <IncompleteIntakeStart/>
                {formsUrl && <div>
                    Need to submit a different claim form?<br/>
                    <a href={findFormsUrlFor(party)!} rel="noopener noreferrer"
                       target="_blank">
                        Visit Forms for {partyPlural}
                    </a>.
                </div>}
                {props.detailsText}
            </div>}
            panelContent={<>
                <IconWithContent icon={PdsIconClock} content={<div>
                    <div>Allow 10-15 minutes to complete the form.</div>
                    <div>
                        <small>
                            Note: you can save your progress if you need to complete the form in multiple sittings. Simply select the "Save
                            progress"
                            button when you are ready to exit and follow the instructions.
                        </small>
                    </div>
                </div>}/>
                <HorizontalRule/>
                {canSignIn(party) && <>
                    <IconWithContent icon={PdsIconEdit} content={
                        <span>
                            Sign in with your Principal.com credentials, and we will fill in what we know about you. Along the way, you can review and make changes as needed.
                        </span>}/>
                    <HorizontalRule/>
                </>}
                <IconWithContent icon={PdsIconPhone} content={
                    <span>
                        If you have any questions about your claim, please call (800) 245-1522 between the hours of 7:30 am and 5:00 pm CT, Monday through Friday.
                    </span>}/>
                <HorizontalRule/>
                <IconWithContent icon={PdsIconFile} content={
                    <>
                        <span style={{ fontWeight: 700 }}>What you'll need to complete this form</span>
                        <ul>
                            {props.neededItems.map(item => <li className="pds-u-padding-top-10">{item}</li>)}
                        </ul>
                        {niceToHaveItems?.length && <>
                            <span style={{ fontWeight: 700 }}>Nice to have</span>
                            <ul>
                                {niceToHaveItems?.map(item => <li className="pds-u-padding-top-10">{item}</li>)}
                            </ul>
                        </>}
                    </>}/>
                <EConsentModal/>
            </>}
        >
        </QuestionPanel>
    )
};

export default Start;